import { S3Client } from "@aws-sdk/client-s3";

const s3AwsClient = new S3Client({
  // endpoint: process.env.REACT_APP_AWS_S3_ENDPOINT, //AWS SDK will automatically resolve the correct endpoint from region.
  region: process.env.REACT_APP_AWS_S3_REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_ACCESS_KEY,
  },
  // forcePathStyle: true, //This is mainly used for:MinIO,custom S3 providers For AWS S3:It’s not needed, Can cause URL/compatibility issues
  requestChecksumCalculation: "WHEN_REQUIRED",
  responseChecksumValidation: "WHEN_REQUIRED"
});

export { s3AwsClient };
